// removed by extract-text-webpack-plugin
module.exports = {"promotionCodeErrorMessage":"Yxg3lDkTks-4ZksLtrAMh","promotionCode":"_16py47d7pJd4B1sMoWGtHJ","promotionCode__title":"IuwZhZJ9G_Y8eSHW7Ye3w","promotionCode__disabled":"_8mnw8QdwAe_SFOeJDVkbF","promotionCode__message":"_12elT0EWFS0-it7ysB3LVC","promotionCode__remove":"_364Z1wXMpzjbiFs20yzctq","m-inline-input-form":"_1VdmU-QmPPMSWiToSKa2fa"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/PromotionCode/style.scss
// module id = 980
// module chunks = 0